import QuickApprovalWorkflow from './QuickApprovalWorkflow';
import DirectLink from './DirectLink';
import NewSQLUser from './NewSQLUser';
import NewADUser from './NewADUser';
import WorkflowTask from './WorkflowTask';

const Modals = {
  QUICK_APPROVAL_WORKFLOW: QuickApprovalWorkflow,
  DIRECT_LINK: DirectLink,
  NEW_SQL_USER: NewSQLUser,
  NEW_AD_USER: NewADUser,
  WORKFLOW_TASK: WorkflowTask,
}

export default Modals;
